import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { LaunchUrgency } from './LaunchUrgency';
import { Section, CTAButton } from './Shared';
export function Pricing() {
  return <Section id="pricing" className="mt-10 max-w-4xl rounded-3xl border border-brand-green/20 bg-brand-surfaceLight/55" data-id="element-271" data-mp="2oiftjbnj6wa9">
      <LaunchUrgency data-id="element-272" data-mp="2jknqpmlclpra" />
      <header className="text-center" data-id="element-273" data-mp="2jk5wevi8xlm0">
        <h2 className="font-display text-4xl font-bold text-brand-dark md:text-5xl" data-id="element-274" data-mp="1vu1vwx0cu1z8">
          Soluciona tus consultas desde hoy
        </h2>
        <p className="mt-3 text-sm text-brand-muted" data-id="element-275" data-mp="1rthv9jgkog8c">
          El precio de lanzamiento cierra pronto. Después sube $18.000.
        </p>
      </header>
      <article className="relative mx-auto mt-9 max-w-2xl overflow-hidden rounded-3xl border-2 border-brand-green bg-brand-cream p-6 shadow-[0_16px_36px_rgba(23,59,43,.14)] md:p-9" data-id="element-276" data-mp="20t4p9k6z2jrd">
        <span className="absolute right-0 top-0 rounded-bl-xl bg-brand-yellow px-4 py-1.5 text-xs font-bold text-brand-deep" data-id="element-277" data-mp="3h9hbtlmit7y0">
          MÁS ELEGIDO
        </span>
        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[.12em] text-brand-green" data-id="element-278" data-mp="3vyf88v2jn63f">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-279" data-mp="4rkq1kfpjkz4" />
          Acceso completo
        </div>
        <h3 className="mt-5 font-serif text-2xl font-bold text-brand-dark md:text-3xl" data-id="element-280" data-mp="9tjvr0yx6tz8">
          CÓDIGO HEPÁTICO™
        </h3>
        <p className="mt-1 text-sm text-brand-muted" data-id="element-281" data-mp="ep8z7fe28v0t">
          1 Ebook Principal + 3 Bonus
        </p>
        <p className="mt-4 text-sm leading-relaxed text-brand-text" data-id="element-282" data-mp="3d6uqyp7v2k5b">
          Ideal para: terapeutas que trabajan con el cuerpo y las emociones y
          quieren integrar un protocolo concreto de salud hepática en su
          práctica profesional desde hoy.
        </p>
        <div className="mt-6 flex items-end justify-between gap-4" data-id="element-283" data-mp="3rzepfck2g3gf">
          <span className="text-sm font-medium text-brand-muted" data-id="element-284" data-mp="2uj99tbrsubqv">
            Inversión única
          </span>
          <div className="text-right" data-id="element-285" data-mp="2zgiw4ijw67ah">
            <p className="text-sm text-brand-muted line-through" data-id="element-286" data-mp="2zfg60cue88vm">
              $348.000 ARS
            </p>
            <p className="font-display text-4xl font-bold leading-none text-brand-green" data-id="element-287" data-mp="2rei8ybdycboj">
              $20.990 ARS
            </p>
          </div>
        </div>
        <CTAButton fullWidth href="https://renacer-hepatico.impultienda.ar/checkout" className="animate-glow-pulse mt-8" data-id="element-288" data-mp="315cxxnil1pdo">
          LO QUIERO — $20.990
        </CTAButton>
        <p className="mt-4 text-center text-xs text-brand-muted" data-id="element-289" data-mp="28hh2sn8nw5j0">
          Garantía 7 días · Descarga inmediata · Pago seguro · Mercado Pago
        </p>
      </article>
    </Section>;
}